<template>
  <CustomPage title="喜欢的发现" style="background: #f7f7f7">
    <div slot="content" style="height: 100%">
      <div class="list-wrapper">
        <VirtualList
          :list="list"
          :dataComponent="dataComponent"
          @getData="getData"
          :finished="finished"
        />
      </div>
    </div>
  </CustomPage>
</template>

<script>
import { getMineLike } from '@/api/setting/index.js'
import CustomPage from '@/components/custom-page.vue'
import dataComponent from '@/views/Discovery/Index/components/Item'
import VirtualList from '@/components/VirtualList'
import { Toast } from 'vant'
export default {
  components: { CustomPage, VirtualList },
  data() {
    return {
      dataComponent,
      loading: false,
      finished: false,
      list: [],
      pagination: {
        total: 0,
        page: 1,
        size: 30,
      },
    }
  },
  methods: {
    getData() {
      const params = {
        page: this.pagination.page - 1,
        size: this.pagination.size,
      }
      this.loading = true
      getMineLike(params)
        .then(res => {
          if (res.data) {
            this.converData(res.data.content)
          } else {
            this.finished = true
          }
        })
        .catch(() => {
          Toast.fail('获取数据失败')
          this.finished = true
        })
    },
    converData(list) {
      const data = list.map((item) => {
        const obj = { desc_fold: null, desc: item.content, fold: false }
        if (item.content.length > 100) {
          obj.desc_fold = item.content.slice(0, 100)
          obj.fold = false
        }
        return { ...item, ...obj, isLike: true, likeList: true }
      })
      this.list.push(...data)
      if (data.length < this.pagination.size) {
        this.finished = true
      } else {
        this.pagination.page++
      }
    },
  },
}
</script>

<style lang="less" scoped>
.record-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .list-wrapper {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>